/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  getLanguageKeys,
  getToken,
  getTextEditor,
  getActiveTextEditor,
  getZoomableInstance
} from '@/store/getters'
import {
  updateActualElement,
  addTextEditor,
  updateEditorState
} from '@/store/actions'
import {
  Editor,
  EditorState,
  convertFromRaw,
  convertToRaw,
  CompositeDecorator
} from 'draft-js'
import { donwloadUsedFonts, prepareToSaveHTML } from './configs/ElementsConfig'

const findLinkEntities = (contentBlock, callback, contentState) => {
  contentBlock.findEntityRanges(character => {
    const entityKey = character.getEntity()
    return (
      entityKey !== null &&
      contentState.getEntity(entityKey).getType() === 'LINK'
    )
  }, callback)
}

const Link = props => {
  const { url, page } = props.contentState.getEntity(props.entityKey).getData()

  return (
    <span
      style={{
        color: (url || page) ? 'blue' : '',
        display: 'inline'
      }}
      className='ba-internal-font'
    >
      {props.children}
    </span>
  )
}

const decorator = new CompositeDecorator([
  {
    strategy: findLinkEntities,
    component: Link
  }
])

// let canSave = true
class TextElement extends Component {
  constructor(props) {
    super(props)
    this.canSave = true
    this.state = {
      editorState: EditorState.createEmpty(decorator),
      isUserTyping: false, // Para controlar se o usuário está digitando
    };
    this.saveTimeout = null; // Para debounce
    this.onChange = this.onChange.bind(this)
    this.onSave = this.onSave.bind(this)
    this.verifyFontsToDownload = this.verifyFontsToDownload.bind(this)
    this.textElement = React.createRef()

  }

 

  /**
   * VERIFY IF IS NEED DOWNLOAD SOME FONTS
   */
  verifyFontsToDownload() {
    const { fontFamilyMap } = this.props.item.content
    donwloadUsedFonts(fontFamilyMap)
  }

  /**
   * When state change
   * @param {EditorState} editorState
   * @param {Boolean} autoSave
   */
  
  
  componentDidMount() {
    const { rawState } = this.props.item.content;
    const editorState = rawState
      ? EditorState.createWithContent(convertFromRaw(rawState))
      : EditorState.createEmpty(decorator);

    this.setState({ editorState });
    this.props.addTextEditor({ id: this.props.id, editorState });
    this.verifyFontsToDownload();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.textEditor !== this.props.textEditor) {
      const newEditorState = this.props.textEditor?.editorState;

      // Atualiza o estado local apenas se o usuário não estiver digitando
      if (newEditorState && !this.state.isUserTyping) {
        this.setState({ editorState: newEditorState });
      }
    }
  }

  onChange = (editorState, autoSave = true) => {
    this.setState({ editorState, isUserTyping: true }); // Marca que o usuário está digitando
    clearTimeout(this.saveTimeout);
    
    this.saveTimeout = setTimeout(() => {
      this.props.updateEditorState({
        id: this.props.id,
        editorState,
      });
      if (this.canSave && autoSave) {
        this.onSave(editorState);
      }
      this.setState({ isUserTyping: false }); // Marca que o usuário parou de digitar
    }, 1000);
  };

  /**
   * Save EditorState
   * @param {EditorState} editorState
   */
  onSave(editorState) {
    this.canSave = false
    const { updateActualElement, id, token, page_id, item } = this.props
    item.content.editorState = null // editorState
    item.content.rawState = convertToRaw(editorState.getCurrentContent())
    item.content.html = prepareToSaveHTML(editorState)

    updateActualElement({
      id: id,
      pageID: page_id,
      element: item,
      accessToken: token,
      onlySave: true
    })

    setTimeout(() => {
      this.canSave = true
    }, 1000)
  }

  /**
   * Verifies that the text editor is active and pauses the panzoom
   */
  onMouseDown(e) {
    const { activeTextEditor, zoomableInstance } = this.props
    /*if ( zoomableInstance.isPaused() ) {
      return
    }*/
    if (!!activeTextEditor) return zoomableInstance.pause()
  }

  render() {
    const { editorState } = this.state
    const { locales, textEditor } = this.props
    const {
      styles,
      colorsMap,
      fontSizeMap,
      fontFamilyMap
    } = this.props.item.content
    const stylesMap = {
      ...colorsMap,
      ...fontSizeMap,
      ...fontFamilyMap,
      HIGHLIGHT: {
        background: '#fffe0d'
      }
    }
    const { textAlign, fontFamily, ...restStyles } = styles

    return (
      <React.Fragment>
        {textEditor && (
          <div
            style={{ ...restStyles }}
            onMouseDown={this.onMouseDown.bind(this)}
          >
            <Editor
              ref={this.textElement}
              placeholder={locales['general-you-text']}
              textAlignment={textAlign}
              editorState={editorState}
              customStyleMap={stylesMap}
              onChange={this.onChange}
              stripPastedStyles={true}
            // readOnly={!!textEditor}
            />
          </div>
        )}
      </React.Fragment>
    )
  }
}
const mapStateToProps = (state, ownProps) => {
  const locales = getLanguageKeys(state)
  const textEditor = getTextEditor(state, ownProps.id)
  const token = getToken(state)
  const activeTextEditor = getActiveTextEditor(state)
  const zoomableInstance = getZoomableInstance(state)
  return { locales, textEditor, token, activeTextEditor, zoomableInstance }
}

const TextWithConnect = connect(
  mapStateToProps,
  { updateActualElement, addTextEditor, updateEditorState }
)(TextElement)
export { TextWithConnect as TextElement }



// WEBPACK FOOTER //
// ./src/components/commons/editor/TextElement.js